var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClipboard = function SvgClipboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.6.1-Queue-/-Registration-/-Lab-number---added",
    transform: "translate(-769.000000, -166.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right",
    transform: "translate(769.000000, 164.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    mask: "url(#mask-2)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 3.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8,1.2 L10.372125,1.2 C10.2488116,1.19987573 10.1381344,1.1243058 10.093125,1.0095 C9.85718501,0.401515538 9.27228476,0.000662309186 8.620125,0 L4.579875,0 C3.92771524,0.000662309186 3.34281499,0.401515538 3.106875,1.0095 C3.06186564,1.1243058 2.95118842,1.19987573 2.827875,1.2 L2.4,1.2 C1.0745166,1.2 0,2.2745166 0,3.6 L0,15.6 C0,16.9254834 1.0745166,18 2.4,18 L10.8,18 C12.1254834,18 13.2,16.9254834 13.2,15.6 L13.2,3.6 C13.2,2.2745166 12.1254834,1.2 10.8,1.2 Z M8.995125,3.6 L4.204875,3.6 C3.87350415,3.6 3.604875,3.33137085 3.604875,3 C3.604875,2.66862915 3.87350415,2.4 4.204875,2.4 L8.995125,2.4 C9.32649585,2.4 9.595125,2.66862915 9.595125,3 C9.595125,3.33137085 9.32649585,3.6 8.995125,3.6 Z"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clipboard.222ea11c.svg";
export { ForwardRef as ReactComponent };